import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {},
} as const satisfies DomainManifest
